import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import MangaCard from "@/components/feature/MangaCard";
import { mangaList } from "@/mocks/manga";

export default function LatestSection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <SectionHeading
            eyebrow="实时更新"
            title="最近更新作品"
            desc="新作连载与完结动态第一时间同步，不错过每一次更新。"
          />
          <Link
            to="/manga"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
          >
            进入漫画库
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {mangaList.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>
      </div>
    </section>
  );
}